<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import type { MenuItemRecord } from '~/types/datocms'
import { AppTheme } from '~/types'

const NuxtLink = resolveComponent('NuxtLink')
const store = useAppStore()
const route = useRoute()
const { menuHide } = useMenu()

interface MenuListItemProps {
  data: MenuItemRecord
  idx: number
  invertColors?: boolean
}

withDefaults(defineProps<MenuListItemProps>(), {
  idx: 0,
  invertColors: false
})
</script>

<template>
  <component
    :is="data.reference !== null ? NuxtLink : data.externalLink ? NuxtLink : 'button'"
    :to="
      data.reference
        ? usePathByType(data.reference._modelApiKey, data.reference?.slug!)
        : data.externalLink
    "
    class="m-i mx-auto inline-block w-fit text-4xl-bl uppercase will-change-transform lg:text-base lg:font-bold"
    :class="[
      `m-i-${idx}`,
      route.path.startsWith('/work/') && 'lg:!text-white',
      {
        'text-black lg:text-white': store.theme === AppTheme.DARK,
        'lg:!text-black': store.theme === AppTheme.DARK && invertColors,
        'text-white lg:text-black': store.theme === AppTheme.LIGHT,
        'lg:!text-white': store.theme === AppTheme.LIGHT && invertColors,
        'text-primary': data.reference !== null && route.params.slug === data.reference?.slug!
      }
    ]"
    @click="menuHide"
  >
    {{ data.title }}
  </component>
</template>
